import ChannelContext from '@jetshop/core/components/ChannelContext';
import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as Caret } from '../../../../svg/Caret.svg';
import { styled } from 'linaria/react';

export const ChannelSelectorWrapper = styled('div')`
  .channel-option {
    width: 100%;

    .options {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      justify-content: center;

      .option {
        display: flex;
        background: transparent;
        align-items: center;
        gap: 0.5rem;
        padding: 0.25rem;
        line-height: 1;
        text-transform: uppercase;
        font-size: 15px;

        &.active {
          text-decoration: underline;
        }
      }
    }
  }
`;

const ChannelOptions = ({ options, selected, clickFunction }) => {
  const sortOptions = [
    ...options.filter(opt => opt.isDefault),
    ...options.filter(opt => !opt.isDefault)
  ];

  return (
    <div className="channel-option">
      <div className="options">
        {sortOptions.map((option, index) => {
          const languageCode = option.culture?.split('-')[0];

          return (
            <button
              key={index}
              onClick={() => clickFunction(option)}
              className={`option ${selected === option ? 'active' : ''}`}
            >
              <span>{languageCode}&nbsp;|&nbsp;SEK</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export const LanguageSelectorDropdown = ({ close, hideDropdown = false }) => {
  const { selectedChannel, updateChannel } = useContext(ChannelContext);

  const [dropdown, setDropdown] = useState(false);

  const [activeChannel] = useState(selectedChannel);

  const wrapperRef = React.createRef();

  useEffect(() => {
    //CLOSE OUTSIDE LISTENER
    const listener = e => {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener('click', listener);
    return () => {
      document.removeEventListener('click', listener);
    };
  }, [setDropdown, wrapperRef]);

  const languageCode = selectedChannel.language?.culture?.split('-')[0];

  return (
    <ChannelSelectorWrapper
      className="channel-selector-wrapper"
      ref={wrapperRef}
      data-open={dropdown}
    >
      {!hideDropdown && (
        <button
          className="channel-selector-button"
          onClick={() => setDropdown(!dropdown)}
        >
          <span className="name">{languageCode}</span>
          <Caret />
        </button>
      )}
      {/*{hideDropdown && <GlobeIcon />}*/}
      {(dropdown || hideDropdown) && (
        <div
          className="channel-selector-dropdown"
          data-dropdown={!hideDropdown}
        >
          <div className="channel-options">
            <ChannelOptions
              options={activeChannel.languages}
              selected={activeChannel.language}
              clickFunction={option => {
                updateChannel({
                  ...activeChannel,
                  language: option
                });
                close();
              }}
              name="Language"
            />
          </div>
        </div>
      )}
    </ChannelSelectorWrapper>
  );
};
